import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import {Button} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import {AppPieChart} from "../app";
import AppLineGraph from "../app/AppLineGraph";
import {config} from "../../../constant";

export default function DialogArchiveCategoryStats({open, onClose, archivePersonId}) {
    const [archivePersonStats, setArchivePersonStats] = useState(null);
    const [tabValue, setTabValue] = useState('1');
    const navigate = useNavigate();

    useEffect(() => {
        fetch(`${config.BASE_URL}/archive-people/stats/${archivePersonId}`)
            .then(response => response.json())
            .then(data => {
                setArchivePersonStats(data);
            })
            .catch((error) => {
                const message = 'Erreur dans la récupération des stats de la personne archive';
                console.error(message, error);
                navigate("/error", {state: {message: message}});
            });
    }, []);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        archivePersonStats && (
            <Dialog open={open} onClose={onClose} maxWidth={'sm'} fullWidth>
                <DialogTitle>Stats de la personne {archivePersonStats.firstName}</DialogTitle>
                <DialogContent>
                    {archivePersonStats.archiveCategoriesWithVictoriousYears.map(archiveCategory => (
                        <Box key={archiveCategory.id} sx={{mt: 1}}>
                            {archiveCategory.name} : {archiveCategory.victoriousYears.length} victoire{archiveCategory.victoriousYears.length > 1 && 's'} ({archiveCategory.victoriousYears.join(', ')})
                        </Box>
                    ))}
                    {/*<Box sx={{ width: '100%', typography: 'body1' }}>*/}
                    <TabContext value={tabValue}>
                        <Box sx={{borderBottom: 1, borderColor: 'divider', mt: 1}}>
                            <TabList onChange={handleTabChange}>
                                <Tab label="Répartition" value="1" />
                                <Tab label="Progression" value="2" />
                            </TabList>
                        </Box>
                        <TabPanel value="1">
                            <AppPieChart
                                chartData={archivePersonStats.archiveCategoriesWithVictoriousYears.map(archiveCategory => {
                                    return {
                                        label: archiveCategory.name,
                                        value: archiveCategory.victoriousYears.length
                                    }
                                })}
                            />
                        </TabPanel>
                        <TabPanel value="2">
                            <AppLineGraph
                                chartLabels={archivePersonStats.progressions.map(progression => progression.year.toString())}
                                chartData={[
                                    {
                                        name: 'Progression',
                                        type: 'line',
                                        fill: 'solid',
                                        data: archivePersonStats.progressions.map(progression => progression.position)
                                    },
                                    {
                                        name: 'Récompenses',
                                        type: 'line',
                                        fill: 'solid',
                                        data: archivePersonStats.progressions.map(progression => progression.nbAwards)
                                    },
                                ]}
                            />
                        </TabPanel>
                    </TabContext>
                    {/*</Box>*/}
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>OK</Button>
                </DialogActions>
            </Dialog>
        )
    );
}
